import { Component } from '@angular/core';
import { appNavItem } from '../../../../libs/shared/ui/theme/material/src/lib/app-nav/app-nav.component';
import { APP_NAV_ITEMS } from './app.nav';

@Component({
  selector: 'ui-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'design-system-docs';
  navItems: appNavItem[] = APP_NAV_ITEMS;
}
